import ServicesApi from "../../apis/Services";

export default {
  namespaced: true,
  state: {
    services: [],
  },
  mutations: {
    set_services(state, data) {
      state.services = data;
    },
  },
  actions: {
    emptyServices({ commit }) {
      commit("set_services", []);
    },
    async getServices({ commit, dispatch }, filters) {
      return await ServicesApi.get_all(filters)
        .then((response) => {
          commit("set_services", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar servicios, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async store({ dispatch }, service) {
      return await ServicesApi.store(service)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El registro se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getServices");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al registrar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async update({ dispatch }, service) {
      return await ServicesApi.update(service)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La actualización se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getServices");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al actualizar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async delete({ dispatch }, service) {
      return await ServicesApi.delete(service)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La eliminación se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getServices");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar eliminar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async change_status({ dispatch }, service) {
      let action = service.active ? "inactivación" : "activación";
      return await ServicesApi.change_status(service)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La " + action + " se relizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getServices");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar realizar la " +
                action +
                ", vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
  },
};
